import { render, staticRenderFns } from "./PlaceInput.vue?vue&type=template&id=b1389f12&"
import script from "./PlaceInput.vue?vue&type=script&lang=js&"
export * from "./PlaceInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports